import React from 'react';

import { StepProps } from './types';

const Step = ({
  children,
  isActive,
  index,
  onStepClick,
  className,
  dataTestId,
}: StepProps) => {
  return (
    <div
      className={`flex items-center justify-center mx-6 w-fit text-14 ${
        isActive ? 'text-black font-semibold' : 'text-gray-300'
      } ${className}`}
      data-testid={dataTestId}
    >
      <div
        onClick={onStepClick}
        className={`w-6 h-6 m-0 p-0 flex mr-1 items-center justify-center rounded-full cursor-pointer ${
          isActive ? 'border-2 border-black' : 'border border-gray-300'
        }`}
      >
        <span className='h-fit w-fit p-0 z-30'>{index}</span>
      </div>
      <div onClick={onStepClick} className='cursor-pointer'>
        {children}
      </div>
    </div>
  );
};

export { Step };
